import React, { useState } from "react";
import {
  Grid,
  CircularProgress,
  Typography,
  Fab,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import VisibilityIcon from "@material-ui/icons/Visibility";
import textLabels from "utils/MUIDataTableTextLabels";
import ModalDetalles from "components/modalDetalles";
import MUIDataTable from "mui-datatables";

import { utcToZonedTime } from "date-fns-tz";
import { format, addHours } from "date-fns";
import differenceInCalendarDays from "date-fns/differenceInCalendarDays";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import axios from "axios";
import { URL_API_REPORTE } from "constantes/urls";
import Search from "@material-ui/icons/Search";

import useStyles from "./reporte.styles";
//sub(new Date(), { days: 1 })
const Reporte = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [carga, setCarga] = useState([]);
  const [tipoCarga, setTipoCarga] = useState(1);
  const [abrirModalDetalle, setAbrirModalDetalle] = useState(false);
  const [tipoAlerta, setTipoAlerta] = useState("error");
  const [mensajeAlerta, setMensajeAlerta] = useState("");
  const [estadoCarga, setEstadoCarga] = useState("todos");
  const [nit, setNit] = useState("");
  const [factura, setFactura] = useState("");
  const [fechaInicio, setFechaInicio] = useState(
    format(new Date(), "yyyy-MM-dd 00:00:00")
  );
  const [fechaFin, setFechaFin] = useState(
    format(new Date(), "yyyy-MM-dd 00:00:00")
  );
  const classes = useStyles();

  const abrirDetalle = (carga) => {
    setCarga(carga);
    setAbrirModalDetalle(true);
  };
  const options = {
    print: false,
    filter: false,
    viewColumns: false,
    filterType: "dropdown",
    responsive: "scrollMaxHeight",
    rowHover: true,
    selectableRows: "none",
    textLabels,
    downloadOptions: {
      filename: tipoCarga === 1 ? "Factura.csv" : "Masivo.csv",
      separator: ";",
    },
  };
  const columns = [
    {
      name: "Id",
      label: "Radicado",
      options: {
        setCellProps: () => ({ style: { minWidth: "30px", maxWidth: "30px" } }),
        customBodyRender: (value) => {
          return (
            <Box
              component="p"
              whiteSpace="normal"
              style={{ wordWrap: "break-word" }}
            >
              {value ? value : "N/A"}
            </Box>
          );
        },
      },
    },
    {
      name: "factura",
      label: "Factura",
    },
    {
      name: "alfa",
      label: "Alfa",
    },
    {
      name: "valorFactura",
      label: "Valor factura",
      options: {
        textAling: "center",
      },
    },
    {
      name: "pbs",
      label: "PBS",
    },
    {
      name: "nitPrestador",
      label: "NIT prestador",
    },
    {
      name: "fechaDeCarga",
      label: "Fecha carga",
    },
    {
      name: "estadoProcesamiento",
      label: "Estado procesamiento",
    },
    {
      name: "cargaExitosa",
      label: "Carga exitosa",
      options: {
        customBodyRender: (value) => (parseInt(value) === 1 ? "Si" : "No"),
      },
    },
    {
      name: "notaProcesamiento",
      label: "Nota procesamiento",
    },
    {
      name: "lote",
      label: "Lote",
    },
    {
      name: "codigoBarras",
      label: "Código de barras",
    },
    {
      name: "estadoRadicacionNemesis",
      label: "Estado radicación Nemesis",
    },
    {
      name: "fechaRadicacionNemesis",
      label: "Fecha de radicación Nemesis",
    },
    {
      name: "logRadicacionNemesis",
      label: "Log radicación Nemesis",
    },

    {
      name: "carpetaDeLaCarga",
      label: "Carpeta de carga",
    },
    {
      name: "tipoCarga",
      label: "Tipo carga",
    },
    {
      name: "procesoP8Exitoso",
      label: "Proceso exitoso P8",
      options: {
        customBodyRender: (value) => (parseInt(value) === 1 ? "Si" : "No"),
      },
    },
    {
      name: "tipoGestion",
      label: "Tipo de Gestión",
    },
    {
      name: "observacion",
      label: "Observación",
    },
    {
      name: "estado",
      label: "Estado",
    },
    {
      name: "notificado",
      label: "Notificado",
    },
    {
      name: "fechaNotificado",
      label: "Fecha de notificado",
    },
    {
      name: "fechaProcesoP8",
      label: "Fecha proceso P8",
    },
    // {
    //   name: 'cargaDetalles',
    //   label: 'Archivos',
    //   options: {
    //     filter: false,
    //     print: false,
    //     download: false,
    //     customBodyRender: (value, tableMeta) => {
    //       return (
    //         <Fab
    //           aria-label='save'
    //           size='small'
    //           onClick={() => abrirDetalle(tableMeta.rowData)}
    //         >
    //           <VisibilityIcon />
    //         </Fab>
    //       )
    //     },
    //   },
    // },
  ];
  const buscar = async () => {
    setMensajeAlerta("");
    var result = differenceInCalendarDays(
      new Date(fechaFin),
      new Date(fechaInicio)
    );
    if (result > 31) {
      setMensajeAlerta(
        "Solo se permite buscar en un rango de fechas no mayor a 30 días"
      );
      return;
    }

    setIsLoading(true);
    try {
      let params = {
        fechaInicio,
        fechaFin,
        estadoCarga,
        nit,
        tipoCarga,
        factura,
      };

      const config = {
        url: URL_API_REPORTE,
        method: "get",
        params,
      };
      setData([]);
      const result = await axios(config);
      if (result) setIsLoading(false);
      if (result.status === 200) setData(result.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Grid container justify="center">
        <Grid item sm={6} xs={12}>
          {mensajeAlerta && (
            <Alert
              severity={tipoAlerta}
              onClose={() => {
                setMensajeAlerta("");
              }}
            >
              {mensajeAlerta}
            </Alert>
          )}
        </Grid>
      </Grid>
      <Grid container justify="center">
        <FormControl
          className={classes.formControl}
          style={{ marginTop: 16, minWidth: 195 }}
        >
          <InputLabel id="tipoCarga-label">Tipo de carga</InputLabel>
          <Select
            labelId="tipoCarga-label"
            id="tipoCarga"
            value={tipoCarga}
            onChange={(e) => setTipoCarga(e.target.value)}
          >
            <MenuItem value={1}>Por factura</MenuItem>
            <MenuItem value={0}>Masiva</MenuItem>
          </Select>
        </FormControl>
        <FormControl
          className={classes.formControl}
          style={{ marginTop: 16, minWidth: 195, marginLeft: 30 }}
        >
          <InputLabel id="estadoCarga-label">Estado Carga</InputLabel>
          <Select
            labelId="estadoCarga-label"
            id="estadoCarga"
            value={estadoCarga}
            onChange={(e) => setEstadoCarga(e.target.value)}
          >
            <MenuItem value="todos">Todos</MenuItem>
            <MenuItem value={1}>Exitosos</MenuItem>
            <MenuItem value={0}>Fallidos</MenuItem>
          </Select>
        </FormControl>
        <TextField
          id="standard-basic"
          label="Nit"
          style={{ marginTop: 16, marginLeft: 30 }}
          value={nit}
          onChange={(e) => setNit(e.target.value)}
        />
        <TextField
          id="standard-basic"
          label="Número Factura"
          style={{ marginTop: 16, marginLeft: 30 }}
          value={factura}
          onChange={(e) => setFactura(e.target.value)}
        />
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
          <KeyboardDatePicker
            style={{ marginLeft: 30 }}
            disableToolbar
            variant="inline"
            format="yyyy-MM-dd"
            margin="normal"
            id="date-picker-inline"
            label="Fecha inicio"
            value={fechaInicio}
            onChange={(date) => setFechaInicio(date)}
            KeyboardButtonProps={{
              "aria-label": "Fecha inicio",
            }}
          />
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
          <KeyboardDatePicker
            style={{ marginLeft: 30 }}
            disableToolbar
            variant="inline"
            format="yyyy-MM-dd"
            margin="normal"
            id="date-picker-inline"
            label="Fecha fin"
            value={fechaFin}
            onChange={(date) => setFechaFin(date)}
            KeyboardButtonProps={{
              "aria-label": "Fecha fin",
            }}
          />
        </MuiPickersUtilsProvider>
        <Fab
          aria-label="save"
          color="primary"
          className={classes.search}
          size="small"
          onClick={buscar}
        >
          <Search />
        </Fab>
      </Grid>

      <Grid
        container
        justify="center"
        alignContent="center"
        style={{ marginTop: "20px" }}
      >
        <Grid item md={12} xs={12}>
          <MUIDataTable
            title={
              <Typography variant="h6">
                Lista de cargas
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={{ ...options, fixedHeader: true }}
          />
        </Grid>
      </Grid>
      {/* <ModalDetalles
        open={abrirModalDetalle}
        handleClose={() => setAbrirModalDetalle(false)}
        carga={carga}
      /> */}
    </div>
  );
};

export default React.memo(Reporte);
